export default class Logger {
  static logMessage(tag, message = '') {
    if (__DEV__) {
      console.tron.log(tag, message);
      console.tron.log(tag, message);
    }
  }
}
